export default __webpack_public_path__ + "static/media/lobbey1.047615b1.jpg";